import { Component, OnInit, Input } from '@angular/core';
import { ApiResource } from 'src/app/resources/api.resource';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-promociones',
  templateUrl: './promociones.component.html',
  styleUrls: ['./promociones.component.sass']
})

export class PromocionesComponent implements OnInit {
  public DatosPromociones = [];
  public Data = [];
  public CodMessage = null;
  public safeUrl = null;
  public mbaasURL = null;
  public cargando = true;
  public HeaderHtml = null;
  public FooterHtml = null;
  public menuHeaderHtml = null;
  public menuFooterHtml = null;
  public BotonesDeSlides = null;
  public sliderHtml = null;
  public tabsHtml = null;
  public responseUuid = null;
  public productsHtml = null;
  public customHtml = null;
  public habilitarPaginaBuscar = false;
  public mostrarActivos = false;
  public configuration = null;
  public formulario = null;
  public mapa = {};
  public departamentosEnCasoDeQueVengaVacioElNodo = [];
  public descargarDocumentos = false;
  public latest_date;

  public imagen_header="https://www.davivienda.com.sv:443/Api-portalDavivienda/media/promo1.jpg";

  constructor(private resource: ApiResource, private rutaActiva: ActivatedRoute,
    private sanitizer: DomSanitizer, private api: ApiService) { }

  ngOnInit() {
    this.latest_date = new Date().toISOString().slice(0, 10);


    if (this.rutaActiva.snapshot.params.uuid) {
      if (this.rutaActiva.snapshot.params.uuid == 'activos') {
        this.obtenerPaginaActivos("portal_principal_personas");
      }
      else if (this.rutaActiva.snapshot.params.uuid == 'documentos') {
        console.log(this.rutaActiva.snapshot.params.uuid);
        this.obtenerPagina("portal_principal_personas");
        this.descargarDocumentos = true;
      }
      else {
        this.obtenerPagina(this.rutaActiva.snapshot.params.uuid);
        this.mostrarActivos = false;
      }
    }
    else {
      this.obtenerPagina("portal_principal_personas");
      this.mostrarActivos = false;
    }

    this.obtenerPromociones();

  }


  public obtenerPromociones() {
    try {
      this.resource.GetPromociones().subscribe(resp => {
        //orden por el campo prioridad
        this.DatosPromociones = resp.response.sort((a, b) => a.prioridad - b.prioridad);
        //pasamos los  datos a un arreglo que contenga los datos con fechas menores a la actual
        for (let i = 0; i < this.DatosPromociones.length; i++) {
          //if (this.DatosPromociones[i].fecha_fin <= this.latest_date) {
            this.Data = this.Data.concat(this.DatosPromociones[i]);
          //}
        }
        
      }, err => {
        console.log('errorErr');
      });
    } catch (error) {
      console.log('catch');
    }
  }

  //inicioo
  public obtenerPagina(uuid): any {


    if (uuid == "activos") {
      this.obtenerPaginaActivos("portal_principal_personas");
    }
    else if (uuid == "documentos") {
      // console.log(uuid);
      this.descargarDocumentos = true;


      let modalForm = $('#documentos');

      if (modalForm.hasClass('active')) {
        $('body').removeClass('overflow-hidden');
      } else {
        $('body').addClass('overflow-hidden');
      }

      modalForm.toggleClass('active');

    }
    else {

      this.mostrarActivos = false;
      this.habilitarPaginaBuscar = true;
      this.sliderHtml = null;
      this.BotonesDeSlides = null;
      this.tabsHtml = null;
      this.responseUuid = null;
      this.productsHtml = null;
      this.customHtml = null;
      this.sliderHtml = null;

      this.habilitarPaginaBuscar = false;
      this.resource.obtenerHtmlPorUUID(uuid).subscribe(
        (resp) => {
          // console.warn("resp", resp);
          this.responseUuid = resp;

          for (let web of resp.elementos_web) {
            if (web.posicion == 'Pre-Header') {
              this.HeaderHtml = web;
            }
            else if (web.posicion == 'Footer') {
              this.FooterHtml = web;
            }
          }

          //verificar si viene formulario
          if (resp.details.formulario) {
            this.formulario = resp.details.formulario;
          }
          else {
            this.formulario = null;
          }

          this.menuFooterHtml = resp.elementos_footer;
          this.menuHeaderHtml = this.crearRowParaContenidoDeMenu(resp.menu);


          // la pagina es de tipo custom
          if (resp.details.tabs == null && resp.details.products == null && resp.details.slides == null) {
            this.customHtml = resp.details;
            console.warn("custom");
          }
          else {
            this.customHtml = null;
          }

          //la pagina es de tipo tabs
          if (resp.details.tabs != null) {
            this.tabsHtml = resp.details;
          }
          else {
            this.tabsHtml = null;
          }


          //la pagina es de tipo producs
          if (resp.details.products != null) {
            this.productsHtml = resp.details;
          }
          else {
            this.productsHtml = null;
          }

          this.configuration = resp.configuration;

          localStorage.setItem("configuracion", JSON.stringify(resp.configuration.general_email));

          this.initFullpage();
          $(".c-body").removeClass("overflow-hidden");
        }
      );
    }
  }

  public obtenerPaginaActivos(uuid): any {
    this.habilitarPaginaBuscar = true;
    this.sliderHtml = null;
    this.BotonesDeSlides = null;
    this.responseUuid = null;
    this.productsHtml = null;
    this.customHtml = null;
    this.sliderHtml = null;

    this.habilitarPaginaBuscar = false;

    this.resource.obtenerHtmlPorUUID(uuid).subscribe(
      (resp) => {
        this.responseUuid = resp;

        for (let web of resp.elementos_web) {
          if (web.posicion == 'Pre-Header') {
            this.HeaderHtml = web;
          }
          else if (web.posicion == 'Footer') {
            this.FooterHtml = web;
          }
        }



        //enviado de datos del correo
        this.configuration = resp.configuration;
        localStorage.setItem("configuracion", JSON.stringify(resp.configuration.general_email));

        //this.configurationEmit.emit(this.configuration);
        // console.warn(" this.configuration",  this.configuration);

        this.menuFooterHtml = resp.elementos_footer;
        this.menuHeaderHtml = this.crearRowParaContenidoDeMenu(resp.menu);
        this.customHtml = null;
        // la pagina es de tipo slides 
        this.BotonesDeSlides = null;
        this.sliderHtml = null;
        //la pagina es de tipo producs      
        this.productsHtml = null;

        this.mostrarActivos = true;

        this.initFullpage();
        $(".c-body").removeClass("overflow-hidden");
      }
    );
  }


  private initFullpage() {
    const $el = document.querySelector('#test-c');

    if ($el) {
      const html = `
          <script>

            if (!window.startIntro) {
              window.startIntro = true;
            }
            setTimeout(function () {
              if ($.fn.fullpage.destroy) {
                $.fn.fullpage.destroy('all');
                // console.warn("$.fn.fullpage.destroy");
              }

              setTimeout(function () {
                $('#fullpage').fullpage({
                  // anchors: ['uno', 'dos', 'tres', 'cuatro'],
                  menu: '#myMenu',
                  scrollingSpeed: 1000,
                  autoScrolling: true,
                  scrollOverflow: false,
                  resize: false,
                  
                  keyboardScrolling: false,
                  afterRender: function () {
                    var $map = document.getElementById('inner-map');
                    var $items = $('#myMenu li');
                    var $next = $('#fp-id-1');

                    $items.removeClass('custom-class-active');
                    $next.addClass('example custom-class-active');
                  },
                  onLeave: function(index, nextIndex, direction) {
                    var $items = $('#myMenu li');
                    var $next = $('#fp-id-'+nextIndex);

                    $items.removeClass('custom-class-active');
                    $next.addClass('custom-class-active');
                  }
                });
              }, 100);
            }, 75);
          </script>
    `;

      const fragment = document.createRange().createContextualFragment(html);
      $el.appendChild(fragment);
    }
  }

  private crearRowParaContenidoDeMenu(array) {
    let i, j, tempArray = [], chunk = 4;
    let innerArray = [];
    for (i = 0, j = array.length; i < j; i++) {
      if (array[i].html_icon !== '-' && array[i].descripcion !== ' ' && array[i].descripcion !== '') {
        innerArray.push(array[i]);
      }
    }
    for (i = 0, j = innerArray.length; i < j; i += chunk) {
      tempArray.push(innerArray.slice(i, i + chunk));
    }
    return tempArray;
  }


  public buscar(buscar) {
    this.sliderHtml = null;
    this.BotonesDeSlides = null;
    this.sliderHtml = null;
    this.responseUuid = null;
    this.productsHtml = null;
    this.customHtml = null;

    this.habilitarPaginaBuscar = true;
  }
}

